import { render, staticRenderFns } from "./tpv-ma-list.vue?vue&type=template&id=5cf11576&scoped=true"
import script from "./tpv-ma-list.vue?vue&type=script&lang=js"
export * from "./tpv-ma-list.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cf11576",
  null
  
)

export default component.exports